import React, { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { HiOutlineBars3 } from "react-icons/hi2";
import { Link, useLocation } from "react-router-dom";
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Divider, Toolbar, IconButton, Drawer, List, ListItemButton, ListItemText, Button, Typography, Box } from "@mui/material";
import AccountMenu from "./AccountMenu";
import { useAuth } from "../Context/AuthContext";

//import "../CSS/NavBar.css";

const NavBar = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  const buttonStyle = {
    textTransform: "none",
    borderColor: "#45C0C0",
    color: "#45C0C0",
    borderRadius: "20px",
    paddingX: "30px",
    "&:hover": {
      borderColor: "#45C0C0",
      backgroundColor: "#45C0C0",
      color: "white",
      transition: "0.3s",
    },
  }

  const menuOptions = [
    { text: "Home", path: "/" },
    { text: "Digital Card", path: "/catalog" },
    // { text: "Service Booking", path: "/service-booking" },
    { text: "Contact Us", path: "/contact-us" }
  ];

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
  }));



  return (
    <AppBar position="relative" className="main-navbar" color="default" elevation={1} sx={{ zIndex: 1200, boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", backgroundColor: "#fff", borderBottom: "1px solid #eee" }}>
      <Toolbar sx={{ justifyContent: "space-between", paddingX: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img src="/sejiwa-logo-2.png" alt="Logo" style={{ width: "30px", height: "30px" }} />
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{
              display: "block",
              fontFamily: '"Fredoka", "Inter", sans-serif',
              fontWeight: 400,
              letterSpacing: "1.5px",
              textDecoration: "none",
              color: "#45C0C0"
            }}
          >
            Sejiwa
          </Typography>
        </Box>
        {/* Desktop Navigation */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 3, alignItems: "center" }}>
          {menuOptions.map((item) => (
            <Button
              key={item.text}
              component={Link}
              to={item.path}
              disableRipple
              sx={{
                textTransform: "none",
                color: location.pathname === item.path ? "#45C0C0" : "#666",
                "&:hover": location.pathname === item.path ? { backgroundColor: "transparent" } : { color: "#454545", backgroundColor: "transparent" },
              }}
            >
              {item.text}
            </Button>
          ))}

          {/* Conditionally show Sign Up or AccountMenu */}
          {!isLoggedIn ? (
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                component={Link}
                to="/login"
                disableRipple
                sx={{
                  textTransform: "none",
                  color: location.pathname === "/login" ? "#45C0C0" : "#666",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                Log In
              </Button>
              <Button
                component={Link}
                to="/register"
                variant="outlined"
                sx={buttonStyle}
              >
                Sign Up
              </Button>
            </Box>
          ) : (
            <AccountMenu />
          )}
        </Box>


        {/* Mobile Actions */}
        <Box sx={{ display: { xs: "flex", md: "none" }, alignItems: "center", gap: 1, ml: "auto" }}>
          {isLoggedIn && <AccountMenu />}
          <IconButton
            edge="end"
            onClick={() => setOpenMenu(true)}
            sx={{ color: "#45C0C0" }}
          >

            <HiOutlineBars3 size={24} />
          </IconButton>
        </Box>
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={openMenu}
        onClose={() => setOpenMenu(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "70%",
          },
        }}
      >

        <DrawerHeader sx={{ justifyContent: 'flex-end' }}>
          <IconButton onClick={() => setOpenMenu(false)}
            sx={{
              color: "#45C0C0",
              p: 0
            }}
          >
            <CloseIcon />
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {menuOptions.map((item) => (
            <ListItemButton key={item.text} component={Link} to={item.path} onClick={() => setOpenMenu(false)} sx={{ color: location.pathname === item.path ? "#45C0C0" : "#666" }}>
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
          {!isLoggedIn ? (
            <>
              <ListItemButton
                component={Link}
                to="/login"
                onClick={() => setOpenMenu(false)}
                disableRipple
                sx={{
                  border: "1px solid #45C0C0",
                  borderRadius: "50px",
                  textAlign: "center",
                  justifyContent: "center",
                  color: "#45C0C0",
                  marginX: "15px",
                  marginTop: "10px",
                  maxHeight: "45px",
                  "&:hover": {
                    backgroundColor: "#45C0C0",
                    color: "white",
                    transition: "0.3s",
                  },
                }}
              >
                <ListItemText primary="Log In" />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/register"
                onClick={() => setOpenMenu(false)}
                disableRipple
                sx={{
                  border: "1px solid #45C0C0",
                  borderRadius: "50px",
                  textAlign: "center",
                  justifyContent: "center",
                  color: "#45C0C0",
                  marginX: "15px",
                  marginTop: "10px",
                  maxHeight: "45px",
                  "&:hover": {
                    backgroundColor: "#45C0C0",
                    color: "white",
                    transition: "0.3s",
                  },
                }}
              >
                <ListItemText primary="Sign Up" />
              </ListItemButton>
            </>
          ) : (
            <></> // Removed AccountMenu from mobile drawer
          )}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default NavBar;
